import {type FilterProvider, ValidationMessage} from '@github-ui/filter'
import {ReposFilter} from '@github-ui/repos-filter'
import {Dialog} from '@primer/react'
import {type RefObject, useState} from 'react'

import {useQueryDefinitions} from '../hooks/use-query-definitions'
import type {PickerScope} from '../types'

interface ReposPickerHeaderContentProps {
  inputRef?: RefObject<HTMLInputElement>
  initialQuery?: string
  dialogTitle: string
  dialogLabelId: string
  dialogDescription?: string
  dialogDescriptionId: string
  scope: PickerScope
  onDismiss: () => void
  onQueryExecuted: (query: string) => void
  onQueryChange?: (query: string) => void
  providers?: FilterProvider[]
  extraValidationMessages?: string[]
}

export function ReposPickerHeaderContent({
  dialogTitle,
  dialogLabelId,
  dialogDescription,
  dialogDescriptionId,
  scope,
  initialQuery = '',
  onDismiss,
  onQueryChange,
  onQueryExecuted,
  inputRef,
  providers,
  extraValidationMessages,
}: ReposPickerHeaderContentProps) {
  const [filterValidationMessages, setFilterValidationMessages] = useState<string[]>([])
  const allValidationMessages = [...(extraValidationMessages || []), ...filterValidationMessages]

  const {data: definitions} = useQueryDefinitions({
    scope,
    enabled: !providers,
  })

  return (
    <div className="p-2 border-bottom">
      <div className="d-flex px-2">
        <div className="d-flex flex-1 pt-2">
          <Dialog.Title id={dialogLabelId}>{dialogTitle}</Dialog.Title>
        </div>
        <Dialog.CloseButton onClose={() => onDismiss()} />
      </div>
      <div className="sr-only" id={dialogDescriptionId}>
        {dialogDescription}
      </div>
      <div className="p-2">
        <ReposFilter
          className={allValidationMessages.length ? 'mb-2' : undefined}
          id="repos-filter"
          inputRef={inputRef}
          onChange={onQueryChange}
          initialFilterValue={initialQuery}
          definitions={definitions ?? []}
          label="Filter repositories"
          variant="input"
          onSubmit={({raw}) => onQueryExecuted(raw)}
          providers={providers}
          onValidation={setFilterValidationMessages}
          showValidationMessage={false}
        />

        <ValidationMessage messages={allValidationMessages} id="repos-filter-validation-message" />
      </div>
    </div>
  )
}

try{ ReposPickerHeaderContent.displayName ||= 'ReposPickerHeaderContent' } catch {}